module.exports = __webpack_public_path__ + "img/app-icon-1.23daf9ab.png";